import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/index.css';
import * as serviceWorker from './serviceWorker';

// 临时关闭错误过滤以查看真实错误
const originalConsoleError = console.error;
console.error = function(...args) {
  // 仅过滤Chrome扩展相关错误
  if (args.length > 0 && typeof args[0] === 'string' &&
      args[0].includes('chrome-extension://')) {
    return;
  }
  originalConsoleError.apply(console, args);
};

// 捕获全局错误
window.addEventListener('error', (event) => {
  // 过滤Chrome扩展相关错误
  if (event.filename && event.filename.includes('chrome-extension://')) {
    event.preventDefault();
    return;
  }
  console.error('全局错误:', event.error);
});

// 添加调试信息
console.log('DestinyCrystal应用启动中...', new Date().toISOString());
console.log('React版本:', React.version);
console.log('环境:', process.env.NODE_ENV);
console.log('Base URL:', window.location.origin);
console.log('PayPal Client ID:', 
  process.env.REACT_APP_PAYPAL_CLIENT_ID ? 
  '已配置 ✅' : 
  '未配置 ❌ - 请设置环境变量REACT_APP_PAYPAL_CLIENT_ID');

// 在挂载失败时提供反馈
try {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    console.error('找不到root元素!');
    document.body.innerHTML = `
      <div style="padding: 20px; text-align: center;">
        <h2>页面加载出错</h2>
        <p>无法找到应用挂载点。请尝试刷新页面或清除浏览器缓存。</p>
      </div>
    `;
  } else {
    console.log('找到root元素，开始渲染');
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.StrictMode>
    );
  }
} catch (error) {
  console.error('应用渲染错误:', error);
  document.body.innerHTML = `
    <div style="padding: 20px; text-align: center;">
      <h2>应用加载失败</h2>
      <p>发生错误: ${error.message}</p>
      <p>请尝试刷新页面或联系管理员。</p>
    </div>
  `;
}

// 注册Service Worker，启用离线缓存
serviceWorker.register({
  onUpdate: registration => {
    // 当有新版本时
    console.log('新版本可用，等待用户操作以更新');
  },
  onSuccess: registration => {
    // 当Service Worker成功注册且资源缓存完成时
    console.log('网站已成功缓存，可以离线访问');
  }
});